import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import '../styles/AppNavbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook, faInstagram} from '@fortawesome/free-brands-svg-icons';
import NavBarLogo from '../assets/NavBarLogo.png';
import PartyNavBarLogo from '../assets/NavBarLogoParty.png';
import NavBarBrand from '../assets/NavBarBrand.png';
import { NavLink } from 'react-router-dom';

export default function AppNavbar() {
  const isAugust = new Date().getMonth() === 7;
  const navbarLogo = isAugust ? PartyNavBarLogo : NavBarLogo;

  return (
    <>
      <Navbar expand="lg" className="navbar-transparent" variant="dark">
        <Container>
          <Navbar.Brand as={NavLink} to="/" className="brand">
            <img src={navbarLogo} alt="Rebirth DnD" className="navbar-logo" />
            <img src={NavBarBrand} alt="Rebirth DnD" className="navbar-text" />
          </Navbar.Brand>

          <Nav className="ms-auto nav-links">
            <Nav.Link as={NavLink} to="/" end>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/current-events">Current Events</Nav.Link>
            <Nav.Link as={NavLink} to="/book-club">Book Club</Nav.Link>
            <Nav.Link as={NavLink} to="/game-masters">Game Masters</Nav.Link>
            <Nav.Link as={NavLink} to="/about">About Us</Nav.Link>
            

            <Nav.Link href="https://www.instagram.com/rebirthdnd/" className="social-link" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} className="social-icon" />
            </Nav.Link>
            <Nav.Link href="https://www.facebook.com/61579321105978" className="social-link" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} className="social-icon" />
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
    </>
  )
}
